import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Popover, Input, Button, ButtonToolbar, Tooltip, OverlayTrigger} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, updateField} from '../../core/redux/form'
import {linkFinder} from '../../core/links'
import extract from '../../core/extract'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import {USAGES, createValidator, UpdateLotCmd} from '../models'
import {UPDATE_LOT_CMD_UPDATED, sendUpdateLotCmd, updateUpdateLotCmd, resetUpdateLotCmd, loadLot} from '../actions'
import i18n from '../i18n'
import style from './UpdateLotPopover.less'

function usageGroupFinder(usage) {
    return (group) => {
        return USAGES[group].find((u) => u == usage) != null
    }
}

class UpdateLotPopover extends Component {

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            activeUsageGroup: Object.keys(USAGES)[0]
        }
    }

    componentWillMount() {
        const {dispatch, lot} = this.props
        dispatch(resetUpdateLotCmd())

        const activeUsageGroup = Object.keys(USAGES).find(usageGroupFinder(lot.usage))
        this.setState({activeUsageGroup})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.lot != this.props.lot) {
            const {dispatch, lot} = nextProps
            dispatch(resetUpdateLotCmd())

            const activeUsageGroup = Object.keys(USAGES).find(usageGroupFinder(lot.usage))
            this.setState({activeUsageGroup})
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendUpdateLotCmd()).then(() => {
            return dispatch(loadLot())
        }).then(() => {
            onHide()
        })
    }

    _selectUsageGroup(event, group) {
        const {dispatch} = this.props

        event.preventDefault()

        dispatch(updateUpdateLotCmd({usage: USAGES[group][0]}))        
        this.setState({activeUsageGroup: group})
    }

    render() {
        const {dispatch, form, cmd, lot, onHide, ...others} = this.props
        const {activeUsageGroup} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const tooltipInputAddon = (text) => (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(text)}>
                <span className={style.info}>?</span>
            </OverlayTrigger>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        return (
            <Popover
                bsClass='popover-md popover'
                title={i18n.updateLot}
                {...others}>
                <div className={style.usageGroup}>
                    <Row>
                        <Col xsHidden sm={3}>
                            <h5>type</h5>
                        </Col>
                        <Col sm={9}>
                            <ul className={style.container}>
                                {Object.keys(USAGES).map((group, index) => (
                                    <li
                                        key={index}
                                        className={cx({[style.active]: activeUsageGroup == group})}>
                                        <a
                                            href=''
                                            onClick={(e) => this._selectUsageGroup(e, group)}>
                                            <Icon
                                                icon={group}
                                                size='md'
                                                active={activeUsageGroup == group} />
                                            <span>{extract(i18n.usageGroupEnum, group)}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                </div>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='select'
                        name='usage'
                        label={requiredLabel(i18n.usage)}
                        {...updateField(form.usage(), lot.usage)}>
                        <option value=''></option>
                        {USAGES[activeUsageGroup].map((usage, index) => (
                            <option
                                key={index}
                                value={usage}>
                                {extract(i18n.usageEnum, usage)}
                            </option>
                        ))}
                    </Input>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='reference'
                        label={requiredLabel(i18n.reference)}
                        addonAfter={tooltipInputAddon(i18n.referenceInfo)}
                        {...updateField(form.ref(), lot.ref)} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='lotNumber'
                        label={requiredLabel(i18n.lotNumber)}
                        addonAfter={tooltipInputAddon(i18n.lotNumberInfo)}
                        {...updateField(form.lotNumber(), lot.lotNumber)} />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
                {lot._links.find(linkFinder('DeleteLot')) && (
                    <div className={style.delete}>
                        <a
                            href=''
                            onClick={(e) => onHide(e, 'DeleteLot')}>
                            {i18n.deleteLot}
                        </a>
                    </div>
                )}
            </Popover>
        )
    }
}

UpdateLotPopover = connectForm({
    target: 'cmd',
    schema: UpdateLotCmd.schema,
    validator: createValidator(),
    action: UPDATE_LOT_CMD_UPDATED
})(UpdateLotPopover)

UpdateLotPopover = connect((state) => ({
    cmd: state.patrimony.updateLotCmd,
    lot: state.patrimony.lot.lot
}))(UpdateLotPopover)

export default UpdateLotPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/UpdateLotPopover.js